import React, { useRef, useEffect, useState } from "react";
import ProductPopup from "../ProductPopup/ProductPopup";
import "./ProductTable.css";
// import PopupChecklist from "../PopupChecklist/PopupChecklist";
// import RowStatusIndicator from "../RowStatusIndicator/RowStatusIndicator";
// import isEqual from "lodash.isequal";
import EditHistoryModal from "../EditHistoryModal/EditHistoryModal";
import ProductTableHeader from "./ProductTableHeader/ProductTableHeader";
import ProductTableRow from "./ProductTableRow/ProductTableRow";
import LocationUpdateButton from "./LocationUpdateButton/LocationUpdateButton";
import ContextMenu from "./ContextMenu/ContextMenu";
import ProductTableFooter from "./ProductTableFooter/ProductTableFooter";
import ProductListButton from "../../Button/ProductListButton";
import {
  canEditRow,
  FileUploadButton,
  calculateFieldTotals,
  NumberPartsEditor,
  getDisplayLabel,
  updatePendingChanges,
  handleDoubleClick,
  SaveChangesButton,
} from "./Utils/Utils";

const ProductTable = ({
  currentProducts,
  fields,
  dropdownData,
  selectedProducts,
  handleSelect,
  handleSelectAll,
  showEdit,
  showDelete,
  handleEdit,
  handleDelete,
  renderField,
  formatFieldName,
  selectedRow,
  setSelectedRow,
  pendingChanges,
  setPendingChanges,
  user,
  handleBulkUpdate,
  filteredProducts,
  status,
  api,
}) => {
  const scrollRef = useRef();
  const [contextMenu, setContextMenu] = useState(null);
  const limitedFields = fields.slice(0, 20);
  const [editingCell, setEditingCell] = useState(null);
  const [editedValue, setEditedValue] = useState("");
  const [logModalData, setLogModalData] = useState({
    show: false,
    productId: null,
  });

  console.log(fields);

  const allFieldNames = Array.isArray(fields)
    ? fields.map((f) => f.fields?.toString())
    : [];

  const userEditable = Array.isArray(user?.fieldsAccess)
    ? user.fieldsAccess.map((f) => f.toString())
    : [];

  const edittableFields = allFieldNames.filter((field) =>
    userEditable.includes(field)
  );

  const totals = calculateFieldTotals(fields, filteredProducts);

  useEffect(() => {
    const slider = scrollRef.current;
    let isDown = false;
    let startX, scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleContextMenu = (e, product) => {
    e.preventDefault();
    setContextMenu({
      x: e.pageX,
      y: e.pageY,
      product,
    });
  };

  const closeContextMenu = () => setContextMenu(null);
  const handleCellClick = (rowId, fieldName, currentValue) => {
    setEditingCell({ rowId, fieldName });
    setEditedValue(currentValue || "");
  };

  const locationFields = fields
    .filter((f) => f.type === "location")
    .map((f) => f.fields);

  return (
    <div onClick={closeContextMenu} className="advanceProduct-table-wrapper">
      <div className="table-scroll-wrapper" ref={scrollRef}>

        {/* Main Table */}
        <table className="advanceProduct-table">
          <ProductTableHeader
            selectedProducts={selectedProducts}
            currentProducts={currentProducts}
            handleSelectAll={handleSelectAll}
            limitedFields={limitedFields}
            formatFieldName={formatFieldName}
          />

          <tbody className="advanceProduct-table-body">
            {currentProducts.map((product) => (
              <ProductTableRow
                key={product._id}
                product={product}
                fields={limitedFields}
                dropdownData={dropdownData}
                selectedProducts={selectedProducts}
                handleSelect={handleSelect}
                handleCellClick={handleCellClick}
                editingCell={editingCell}
                editedValue={editedValue}
                setEditedValue={setEditedValue}
                setEditingCell={setEditingCell}
                pendingChanges={pendingChanges}
                setPendingChanges={setPendingChanges}
                user={user}
                status={status}
                canEditRow={canEditRow}
                FileUploadButton={FileUploadButton}
                NumberPartsEditor={NumberPartsEditor}
                renderField={renderField}
                handleContextMenu={handleContextMenu}
                currentProducts={currentProducts}
                getDisplayLabel={getDisplayLabel}
                updatePendingChanges={updatePendingChanges}
                handleDoubleClick={handleDoubleClick}
              />
            ))}

            {currentProducts.length === 0 && (
              <tr className="no-data-row">
                <td colSpan={limitedFields.length + 1} className="no-data-cell">
                  No data available for the current filter.
                </td>
              </tr>
            )}
          </tbody>

          {/* Table Footer Totals */}
          <ProductTableFooter fields={limitedFields} totals={totals} />

        </table>
      </div>

      {/* Context Menu */}
      {contextMenu && (
        <ContextMenu
          contextMenu={contextMenu}
          showEdit={showEdit}
          showDelete={showDelete}
          onView={() => {
            setSelectedRow(contextMenu.product);
            setContextMenu(null);
          }}
          onEdit={() => {
            handleEdit(contextMenu.product._id);
            setContextMenu(null);
          }}
          onDelete={() => {
            handleDelete(contextMenu.product._id);
            setContextMenu(null);
          }}
          onViewLogs={() => {
            setLogModalData({
              show: true,
              productId: contextMenu.product._id,
            });
            setContextMenu(null);
          }}
        />
      )}

      {/* Product Details Popup */}
      {selectedRow && (
        <ProductPopup
          product={selectedRow}
          fields={fields}
          dropdownData={dropdownData}
          onClose={() => setSelectedRow(null)}
          handleEdit={handleEdit}
          handleDelete={showDelete ? handleDelete : null}
          showEdit={showEdit}
          showDelete={showDelete}
        />
      )}

      {/* Edit History Modal */}
      {logModalData.show && (
        <EditHistoryModal
          entryId={logModalData.productId}
          apiUrl={`${api}`}
          onClose={() => setLogModalData({ show: false, productId: null })}
        />
      )}
    </div>
  );
};

export default ProductTable;
